'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSwitchCamera = function ImageSwitchCamera(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
  );
};
ImageSwitchCamera = (0, _pure2.default)(ImageSwitchCamera);
ImageSwitchCamera.displayName = 'ImageSwitchCamera';
ImageSwitchCamera.muiName = 'SvgIcon';

exports.default = ImageSwitchCamera;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/switch-camera.js
// module id = 2470
// module chunks = 0